import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';

import { Grid, Button, Chip, Card, CardContent, Paper, Divider, IconButton } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import ArrowRightIcon from '@material-ui/icons/ChevronRightRounded';

const styles = theme => ({
    layoutRoot: {},
    cardUtama: {
        borderRadius: 0
    },
    poinRincian: {
        marginBottom: '5px'
    },
    headerTabel: {
        fontWeight: 'bold',
        fontSize: '15px',
        textAlign: 'right'
    }
});

class RincianKemajuan extends Component {
    state = {
        error: 0,
        kuesionerInduk: {},
        routeParams: {
            token: null,
            start: 0,
            limit: 20,
            pengguna_id: null,
            load_children: 0,
            tingkat_instrumen: 2,
            tahun_ajaran_id: localStorage.getItem('tahun'),
            tahun: localStorage.getItem('tahun'),
            kode: null
        },
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    getJenjangResponden = (sekolah, pengguna) => {
        let arrReturn = {};

        if(Number(pengguna.peran_id) === 10){
            arrReturn.responden = 'kepsek';
        }else if(Number(pengguna.peran_id) === 12 || Number(pengguna.peran_id) === 90){
            arrReturn.responden = 'siswa';
        }else if(Number(pengguna.peran_id) === 13){
            arrReturn.responden = 'pengawas';
        }else if(Number(pengguna.peran_id) === 14){
            arrReturn.responden = 'komite';
        }else if(Number(pengguna.peran_id) === 53){
            arrReturn.responden = 'guru';
        }
        
        // if(Number(sekolah.bentuk_pendidikan_id) === 5){
        //     arrReturn.jenjang = 'SD';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
        //     arrReturn.jenjang = 'SMP';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
        //     arrReturn.jenjang = 'SMA';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
        //     arrReturn.jenjang = 'SMK';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
        //     arrReturn.jenjang = 'SLB';
        // }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
        //     arrReturn.jenjang = 'SLB';
        // }

        if(Number(sekolah.bentuk_pendidikan_id) === 5){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 53){
            arrReturn.jenjang = 'SD';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 6){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 54){
            arrReturn.jenjang = 'SMP';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 13){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 55){
            arrReturn.jenjang = 'SMA';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 15){
            arrReturn.jenjang = 'SMK';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 29){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 7){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 8){
            arrReturn.jenjang = 'SLB';
        }else if(Number(sekolah.bentuk_pendidikan_id) === 14){
            arrReturn.jenjang = 'SLB';
        }

        return arrReturn;
    }

    componentDidMount = () => {
        this.props.setJudul('Rincian Pengisian');

        if(typeof this.props.location.pathname.split('/')[3] !== 'undefined') {
            // this.state.nomor = this.props.location.pathname.split('/')[3];
            this.setState({
                nomor: this.props.location.pathname.split('/')[3]
            });
        }

        // console.log(this.props.sekolah);

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                token: localStorage.getItem('jwt_token'),
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                kode: this.props.location.pathname.split('/')[2]
            }
        }, () => {
            this.props.getKuesioner(this.state.routeParams).then((result)=>{
                // console.log(result.payload);
                this.setState({
                    ...this.state,
                    kuesionerInduk: result.payload.rows[0],
                    instrumen_id: result.payload.rows[0].instrumen_id
                },()=>{
                    console.log(this.state.kuesionerInduk.kode);
                });
            });
        });

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                token: localStorage.getItem('jwt_token'),
                kode: this.props.location.pathname.split('/')[2],
                pengguna_id: JSON.parse(localStorage.getItem('user')).pengguna_id,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id
            }
        },()=>{
            this.props.setLoading('block');
            
            this.props.getSekolah(this.state.routeParams).then((result)=>{
                
                this.setState({
                    ...this.state,
                    routeParams: {
                        ...this.state.routeParams,
                        jenjang: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).jenjang,
                        responden: this.getJenjangResponden(this.props.sekolah, JSON.parse(localStorage.getItem('user'))).responden
                    }
                }, ()=>{
                    this.props.getRincianRekapKemajuan(this.state.routeParams).then((result)=>{
                        this.props.setLoading('none');
                    });
                });

            })

        })

    }

    render()
    {
        const {classes} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://'+window.location.host+'/assets/images/backgrounds/kemajuan.png)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 89}}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={9} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>{this.state.kuesionerInduk.kode}. {this.state.kuesionerInduk.judul}</h1>
                                </Grid>
                                <Grid item xs={12} sm={3} style={{textAlign: 'right'}}>
                                    <Button variant="contained" color="secondary" size="small" onClick={()=>{this.props.history.push('/LembarInstrumen/'+this.state.kuesionerInduk.kode)}}><EditIcon/> &nbsp;&nbsp; Lanjutkan </Button>
                                </Grid>
                            </Grid>
                        </div>
                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Isi Kuesioner"
                                className={this.props.classes.chip}
                                color="primary"
                                onClick={()=>{this.goTolink('/PerangkatKuesioner')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                            <Chip
                                label={"> Rincian Progres Pengisian ("+this.state.kuesionerInduk.kode + ". "  + this.state.kuesionerInduk.judul + ")"}
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        <Card className={classes.cardUtama}>
                            <CardContent>
                                <Paper className="p-16 headerTabel">
                                    <Grid container>
                                        <Grid item xs={12} sm={4} style={{border: '0px solid #ccc', textAlign: 'left'}} className={classes.headerTabel}>
                                            Pertanyaan
                                        </Grid>
                                        <Grid item xs={9} sm={6} style={{border: '0px solid #ccc',}}>
                                            <Grid container>
                                                <Grid item xs={12} sm={4} className={classes.headerTabel}>
                                                    Butir Total
                                                </Grid>
                                                <Grid item xs={12} sm={4} className={classes.headerTabel}>
                                                    Butir Terjawab
                                                </Grid>
                                                <Grid item xs={12} sm={4} className={classes.headerTabel}>
                                                    Persentase
                                                </Grid>
                                                
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3} sm={2} style={{border: '0px solid #ccc'}}>
                                            <Grid container>
                                                <Grid item xs={6} sm={6} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    Status
                                                </Grid>
                                                <Grid item xs={6} sm={6} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    &nbsp;
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* <Grid item xs={12} sm={8} style={{border: '0px solid #ccc'}} className={classes.headerTabel}>
                                            <Grid container>
                                                <Grid item xs={3} sm={3} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    Butir Total
                                                </Grid>
                                                <Grid item xs={3} sm={3} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    Butir Terjawab
                                                </Grid>
                                                <Grid item xs={2} sm={2} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    Persentase
                                                </Grid>
                                                <Grid item xs={2} sm={2} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    Status
                                                </Grid>
                                                <Grid item xs={2} sm={2} style={{textAlign: 'right', border: '0px solid #ccc'}} className={classes.headerTabel}>
                                                    
                                                </Grid>
                                            </Grid>
                                        </Grid> */}
                                    </Grid>
                                </Paper>
                                <Divider/>
                                <br/>
                                {this.props.rincian_rekap_kemajuan.rows.map((option)=>{

                                    // console.log(option);

                                    return (
                                        <Paper className={"p-16 " + classes.Paper + " " + classes.poinRincian}>
                                            <Grid container>
                                                <Grid item xs={12} sm={4} style={{border: '0px solid #ccc'}}>
                                                    <b>{option.kode}</b> {option.judul}
                                                    <br/>{parseInt(this.props.rincian_rekap_kemajuan.rows.indexOf(option)+1)}
                                                </Grid>
                                                <Grid item xs={9} sm={6} style={{border: '0px solid #ccc',}}>
                                                    <Grid container>
                                                        <Grid item xs={12} sm={4} className="kolomButir">
                                                            <span className="keteranganMobile">Butir Total: </span> {option.jumlah_total}
                                                        </Grid>
                                                        <Grid item xs={12} sm={4} className="kolomButir">
                                                            <span className="keteranganMobile">Butir Terjawab: </span> {option.jumlah_terjawab}
                                                        </Grid>
                                                        <Grid item xs={12} sm={4} className="kolomButir">
                                                            <span className="keteranganMobile">Persentase: </span> {option.persentase}%
                                                        </Grid>
                                                        
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={3} sm={2} style={{border: '0px solid #ccc'}}>
                                                    <Grid container>
                                                        <Grid item xs={6} sm={6} style={{textAlign: 'right', border: '0px solid #ccc', paddingTop: '12px'}}>
                                                            {option.persentase === "100.00" && <CheckIcon style={{color:'green'}} />}
                                                            {option.persentase !== "100.00" && <CancelIcon style={{color:'red'}} />}
                                                        </Grid>
                                                        <Grid item xs={6} sm={6} style={{textAlign: 'right', border: '0px solid #ccc'}}>
                                                            <IconButton color="primary" size="small" onClick={()=>{this.props.history.push('/LembarInstrumen/'+this.state.kuesionerInduk.kode+"/"+parseInt(this.props.rincian_rekap_kemajuan.rows.indexOf(option)+1))}}><ArrowRightIcon/></IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    )
                                })}
                            </CardContent>
                        </Card>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setKuesioner: Actions.setKuesioner,
        getKuesioner: Actions.getKuesioner,
        setKuesionerDirty: Actions.setKuesionerDirty,
        setRadioKuesioner: Actions.setRadioKuesioner,
        simpanKuesioner: Actions.simpanKuesioner,
        getRekapKemajuan: Actions.getRekapKemajuan,
        hitungRekapKemajuan: Actions.hitungRekapKemajuan,
        getRincianRekapKemajuan: Actions.getRincianRekapKemajuan,
        getSekolah: Actions.getSekolah,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Instrumen, Sekolah, App }) {

    // console.log(Instrumen.kuesioner);

    return {
        kuesioner: Instrumen.kuesioner,
        fetch_kuesioner: Instrumen.fetch_kuesioner,
        hasil_simpan: Instrumen.hasil_simpan,
        dirty: Instrumen.dirty,
        radioCheck: Instrumen.radioCheck,
        rekap_kemajuan: Instrumen.rekap_kemajuan,
        rincian_rekap_kemajuan: Instrumen.rincian_rekap_kemajuan,
        sekolah: Sekolah.sekolah,
        loading: App.loading
    }
}

// export default withStyles(styles, {withTheme: true})(Instrumen);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RincianKemajuan)));




// WEBPACK FOOTER //
// ./src/main/content/Instrumen/RincianKemajuan.js